"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAdornmentRight = void 0;
var _AdornmentRight = require("./AdornmentRight");
// TODO: in v9, move styled() from AdornmentRight.jsx to here
var StyledAdornmentRight = _AdornmentRight.AdornmentRight;
exports.StyledAdornmentRight = StyledAdornmentRight;